export type RecordingPosition = { x: number; y: number };
export type RecordingBox = RecordingPosition & { width: number; height: number };

/** Offsets and the unshifted actor box use fractions of the recording frame. */
export function constrainRecordingPosition(position: RecordingPosition, origin: RecordingBox): RecordingPosition {
  const clamp = (value: number, start: number, size: number) => {
    const min = -start, max = 1 - start - size;
    return min > max ? (min + max) / 2 : Math.max(min, Math.min(max, value));
  };
  return { x: clamp(position.x, origin.x, origin.width), y: clamp(position.y, origin.y, origin.height) };
}

export function recordingPositionKey(key: string, shift: boolean): RecordingPosition | null {
  const step = shift ? .05 : .01;
  switch (key) {
    case "ArrowLeft": return { x: -step, y: 0 };
    case "ArrowRight": return { x: step, y: 0 };
    case "ArrowUp": return { x: 0, y: -step };
    case "ArrowDown": return { x: 0, y: step };
    default: return null;
  }
}
